import { Component, OnInit, Inject } from '@angular/core';
import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-followed-analyst-list',
  templateUrl: './followed-analyst-list.component.html',
  styleUrls: ['./followed-analyst-list.component.css']
})
export class FollowedAnalystListComponent implements OnInit {
  filterObj: any = {}
  userDetailsObject: object;
  analystData;
  viewProfileDrop;
  userRole: string;
  loggedInStatus;
  searchString = "";
  sortSelectedindex = null;
  noResearchData: boolean;
  userId: string;

  constructor(
    public rolesSharedService: RolesSharedService,
    private authenticationService: AuthenticationService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.document.body.classList.add("inner-page");
    this.document.body.classList.remove("outer-page");
   // window.scroll(0, 0);
  }

  ngOnInit() {
    this.userDetails();
    this.getAnalystList();
    this.isLoggedIn();
  }

  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.userId = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      ).userId;

    }
  }

  isLoggedIn() {
    if (this.authenticationService.isLoggedIn()) {
      this.loggedInStatus = true;
      this.getRole();
    } else {
      this.loggedInStatus = false;
    }
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }

  getAnalystListFilter() {
    const filter: any = {};
    filter.filter = JSON.stringify({
      where: {
        and: [
          {
            "name": {
              "ilike": `%${this.searchString}%`
            }
          },
          {
            code: "tech_analyst"
          }
        ]
      },
      include: [{
        relation: "followers"
      }, "ratings"]
    });
    return filter;
  }

  getAnalystList() {
    this.rolesSharedService.getAnalystList(this.getAnalystListFilter()).subscribe((data: any) => {
      this.analystData = data;
      if (data.length == 0) {
        this.noResearchData = true;
      } else {
        this.noResearchData = false;
      }
    });
  }

  changeStyle($event, data, index) {
    data.drop = $event.type == "mouseover" ? true : false;
  }

  followAnalyst(AnalystData, index) {
    const filter: any = {}
    filter.filter = JSON.stringify({
      analystUserId: AnalystData.id,
      followerUserId: this.userId
    })
    this.rolesSharedService.analystFollow(filter.filter).subscribe(
      followResponse => {
        if (followResponse["followed"]) {
          // case when user is liked and updated in server
          AnalystData.isFollow = true;
          AnalystData.followerCount += 1;
        } else if (!followResponse["followed"]) {
          // case when user is not liked and updated in server
          AnalystData.isFollow = false;
          AnalystData.followerCount -= 1;
        }
      });
  }

  featureUnderConstructionNavigation() {
    if (this.loggedInStatus) {
      this.router.navigate([`${this.userRole}/under-construction`]);
    } else {
      this.router.navigate([`under-construction`]);
    }
  }


  routeTechAnalystProfilePage(analystId: string, firstName, secondName) {
    sessionStorage.removeItem('sheduleCallUrl');
    sessionStorage.removeItem('sheduleCallLabel');
    sessionStorage.setItem('analystName', firstName + ' ' + secondName);
    this.router.navigate(['analyst-profile'], { queryParams: { analystId: analystId } })
  }

  schdeuleCall(analystId) {
    let filterData = {
      'analystId': analystId,
      'timeZone': "Asia/Singapore",
      "date": "2018-08-13"
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/followed-analyst-list/followed-analyst-list.component.ts